import storage from '@/utils/storage'
import { isDev } from '@/utils/miscellaneous'
import { MAX_FREE_CONVERSION_PER_DAY } from '@/utils/conversion'
import { MAX_FREE_COMPRESSION_PER_DAY } from '@/utils/compression'
import type { AccessControlGroups } from '@/types/accessControl'

export function incrementOperationHistory(group: AccessControlGroups): void {
  const localStorage = storage('localStorage')

  const storageKey = `${group}-history`
  const currentDate = new Date().toLocaleDateString()
  const operationHistory = localStorage.getItem<Record<string, number>>(storageKey) || {}

  if (!operationHistory[currentDate]) {
    operationHistory[currentDate] = 0
  }

  operationHistory[currentDate]++

  // trimming operation history to only last 10 entries
  const recentOperationHistory = Object.fromEntries(
    Object.entries(operationHistory).slice(-10)
  )

  return localStorage.setItem(storageKey, recentOperationHistory)
}

export function getFreeOperationPerDay(group: AccessControlGroups): number {
  if (isDev()) {
    // unlimited conversions in development mode
    return 0
  }

  if (group === 'conversion') {
    return MAX_FREE_CONVERSION_PER_DAY
  }

  if (group === 'compression') {
    return MAX_FREE_COMPRESSION_PER_DAY
  }

  return 1
}

export function hasFreeOperations(group: AccessControlGroups): boolean {
  const localStorage = storage('localStorage')
  const maxFreeOperationPerDay = getFreeOperationPerDay(group)

  if (maxFreeOperationPerDay === null || maxFreeOperationPerDay < 1) {
    return true
  }

  const storageKey = `${group}-history`
  const currentDate = new Date().toLocaleDateString()
  const operationHistory = localStorage.getItem<Record<string, number>>(storageKey) || {}

  if (!operationHistory[currentDate]) {
    return true
  }

  return operationHistory[currentDate] < maxFreeOperationPerDay
}
